import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["row", "input"]

  show(event) {
    event.preventDefault();
    this.rowTarget.classList.remove('d-none');
    this.inputTarget.focus();
  }

  hide(event) {
    event.preventDefault();
    this.rowTarget.classList.add('d-none');
    this.inputTarget.value = '';
  }
}
